import { Audit, AuditStatus } from "@/_models/audit.interface";
import { DateUtils } from "@/_utility/DateTimeFormat";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { Component, Input, OnChanges } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { TagModule } from "primeng/tag";

@Component({
    selector: "app-audit-task-card",
    standalone: true,
    imports: [CommonModule, SharedComponentsModule, RouterModule, TagModule],
    templateUrl: "./audit-task-card.component.html",
    styleUrls: [
        "./audit-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class AuditTaskCardComponent implements OnChanges {
    @Input() audit: Audit;
    @Input() isLast: boolean = false;

    title: string = "Untitled Audit";
    status: string = AuditStatus.Scheduled;
    dueDateLabel: string = "";

    constructor(private dateUtils: DateUtils) {}

    ngOnChanges(): void {
        if (!this.audit) {
            return;
        }

        this.title = this.audit.title || "Untitled Audit";
        this.status = this.audit.status || AuditStatus.Scheduled;
        this.dueDateLabel = this.audit.dueDate
            ? this.dateUtils.formatDateWithConditionalYear(this.audit.dueDate)
            : "";
    }
}
